import { useState, useEffect } from 'react';
import Placeholder from 'react-bootstrap/Placeholder';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import { useAppConfig } from '../config/AppConfigContext';
import { GetAccessToken } from "../index";
import { useMsal } from "@azure/msal-react";
export function AdminReports({ ...props }) {
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug","Sept", "Oct","Nov","Dec"
    ];

    // Generate last 5 years
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth(); // Get the current month (0-11)
    const years = [];
    for (let i = currentYear; i >= currentYear-5; i--) {
        years.push(i);
    }

    // Create an array for month-year combinations
    const monthsAndYears = [];
    for (let year of years) {
        // If we are in the current year, limit the months to the current month
        const startMonth = year === currentYear ? currentMonth + 1 : 12; // Current month in 1-based (1 to 12)
        for (let month = startMonth; month >= 1; month--) {
            monthsAndYears.push({
                label: `${months[month - 1]} ${year}`,
                value: `${month}-${year}`,
            });
        }
    }

    const [officeName, setOfficeName] = useState('');
    const [error, setError] = useState('');
    const [isOrgVisible, setOrgIsVisible] = useState(true);
    const [searchOrgResults, setOrgSearchResults] = useState([]);
    const [csvData, setCsvData] = useState(null); // State to store the parsed CSV data
    const [selectedMonthYear, setSelectedMonthYear] = useState(`${currentYear}- 1`); // Default to March of the current year
    const [file, setfile] = useState(null);
    const config = useAppConfig();
    const { instance } = useMsal();
    const [saleType, setsaleType] = useState('Residential');

    // Handle the office name input change
    const handleInputChange = (event) => {
        setOfficeName(event.target.value);
        if (officeName.length >= 4) {
            handleConjointOffices();
        }
    };
    const handleConjointOffices = async () => {
        const url = "api/organisation/GetOrganisation";
        //const tokenRequest = {
        //    scopes: ["https://reinztestorg.onmicrosoft.com/app_token/api_access"],
        //   account: instance.getActiveAccount()
        //};
        /*const accessToken = await GetAccessToken(tokenRequest);*/
        try {
            fetch(url, {
                method: "POST",
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    /*'Authorization': `Bearer ${accessToken}`*/
                }),
                body: JSON.stringify(officeName)
            })
                .then((response) => {
                    console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                }).then(data => {
                    console.log(data)
                    if (data !== null && data !== undefined) {
                        setOrgSearchResults(data);
                        setOrgIsVisible(true);
                    }
                })
                .catch(error => {
                    console.error('Error fetching organisations', error);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }
    const handleSelectOrg = (org) => {
        setOrgIsVisible(!isOrgVisible);
        setOfficeName(org);
    };

    // Handle the Sales Returns By Office and download CSV
    const handleSearchAndDownload = async () => {
        if (!officeName) {
            setError('Please enter an office name');
            return;
        }
        setError('');

        try {
            // Use fetch to get the CSV file from the backend
            const response = await fetch(`/api/reports/officesalesreturn?officeName=${officeName}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('An error occurred while downloading the report');
            }
            const blob = await response.blob(); // Convert the response to a Blob
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob); // Create a URL for the Blob object
            link.download = `${officeName} Sales Report.csv`; // Set the filename
            link.click(); // Trigger the download
        } catch (error) {
            console.error('Error fetching CSV:', error);
            setError(error.message);
        }
    };
    
    // Handle dropdown change for duplicate returns
    const handleSelectChange = (event) => {
        if (event.target.id === "DuplicateReturns") {
            setSelectedMonthYear(event.target.value);
        }
        setSelectedMonthYear(event.target.value);
    };

    // Handle duplicate returns and CSV download 
    const download_duplicate_returnsCsv = async () => {
        const [month, year] = selectedMonthYear.split('-');
        try {
            const response = await fetch(`/api/reports/duplicatereturns/${month}/${year}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch CSV');
            }

            const blob = await response.blob(); // Convert the response to a Blob
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob); // Create a URL for the Blob object
            link.download = `REINZ Duplicate Returns ${month} ${year}.csv`; // Set the filename
            link.click(); // Trigger the download
        }
        catch (error) {
            console.error('Error fetching CSV:', error);
        }
    };

        // Handle office Summary Report and CSV download
    const download_office_summaryCsv = async () => {
            const [month, year] = selectedMonthYear.split('-');
            try {
                const response = await fetch(`/api/reports/officesummaryreport/${month}/${year}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch CSV');
                }

                const blob = await response.blob(); // Convert the response to a Blob
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob); // Create a URL for the Blob object
                link.download = `REINZ Office Summary ${month} ${year}.csv`; // Set the filename
                link.click(); // Trigger the download
            }
            catch (error) {
                console.error('Error fetching CSV:', error);
            }
    };
    //Handle csv file upload
    const handleSalesFileChange = async (e) => {
        if (e.target.files && e.target.files[0])
        {
            setfile(e.target.files[0]);
        }
        else {
        console.error("No file selected.");
    }
            
    }
    //Handle saletype for manual sales upload
    const handleSaleType = async (e) => {
        console.log(e.target.value);
        setsaleType(e.target.value);
    }
    const handleManualSalesUpload = async () => {
        if (!file) return alert("Please select a file");
        if (!saleType) return alert("Please select a sale type.")

        const formData = new FormData();
        formData.append("file", file);
        formData.append("saleType", saleType)
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);
        try {
            const response = await fetch(`/api/reports/manualsalesupload`, {
                method: 'POST',
                headers: {
                    /*'Content-Type': 'multipart/form-data',*/
                    'Authorization': `Bearer ${accessToken}`
                },
                body: formData
            });
            const result = await response.text();
            if (result) {
                alert(result.message || "Upload succeeded"); 
            }
            else
            {
                throw new Error('Failed to upload.');
            }
        }
        catch (error) {
            console.error(error);
            alert(error.response?.data.message||"Upload failed");
        }

    }


    return (
        <>
            <div className="container" id="AddResidentialReturn">
               <h1>Admin Reports</h1>
                {/*<Button style={{ backgroundColor: "#331b8c", border: 'none' }} size="sm" onClick={props.onGoBack}>*/}
                {/*<i className="bi bi-arrow-left-square"></i>&nbsp;Back*/}
                {/*</Button><br /><br/>*/}
                <h3>Default Reports</h3>
                <h6>These reports are generated by REINZ for specific purposes, and are different from reports generated in the Report Studio.</h6>
                <h5>Sales Returns Admin Reports</h5><hr></hr>

                {/*Duplicate Returns Report*/}
                <h5 style={{ paddingLeft: "100px" }}>Duplicate Returns Report <span style={{ color: "GrayText" }}>CSV File</span></h5>
                <div style={{paddingLeft: "120px", fontSize: '15px' }}>Date:&nbsp;&nbsp;&nbsp;
                    <select id="DuplicateReturns" value={selectedMonthYear} onChange={handleSelectChange}>
                        {monthsAndYears.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>&nbsp;&nbsp;&nbsp;
                    <Button style={{ backgroundColor: "#331b8c", border: 'none' }} size="sm" onClick={download_duplicate_returnsCsv}><i className="fa fa-download"></i>&nbsp;
                    Download</Button>
                </div><br />
                {/*Office Summary Report CSV File*/}
                <h5 style={{ paddingLeft: "100px" }}>Office Summary Report <span style={{ color: "GrayText" }}>CSV File</span></h5>
                <div style={{ paddingLeft: "120px", fontSize: '15px' }}>Date:&nbsp;&nbsp;&nbsp;
                    <select id="OfficeSummary" value={selectedMonthYear} onChange={handleSelectChange}>
                        {monthsAndYears.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>&nbsp;&nbsp;&nbsp;
                    <Button style={{ backgroundColor: "#331b8c", border: 'none' }} size="sm" onClick={download_office_summaryCsv}><i className="fa fa-download"></i>&nbsp;
                    Download</Button>
                </div><br />
                {/*Sales Returns By Office*/}
                <h5 style={{ paddingLeft: "100px" }}>Sales Returns By Office <span style={{ color: "GrayText" }}>CSV File</span></h5>
                
                <div style={{ paddingLeft: "120px", fontSize: '15px' }}>Office:&nbsp;&nbsp;&nbsp;
                    <input
                        type="text"
                        value={officeName}
                        onChange={handleInputChange}
                        placeholder="Search offices and agencies"
                        style={{ width: '300px' }} // Adjust width as needed
                    />&nbsp;&nbsp;&nbsp;
                    <Button style={{ backgroundColor: "#331b8c", border: 'none' }} size="sm" onClick={handleSearchAndDownload}><i className="fa fa-download"></i>&nbsp;
                    Download
                    </Button>
                    {error && <div style={{ color: 'red' }}>{error}</div>}
                    {isOrgVisible &&
                        <ul id="ConjointOfficeReinzId" className="List">
                            {searchOrgResults.map((org, index) => (
                                <li key={index} onClick={() => handleSelectOrg(org)}>
                                    {org}
                                </li>
                            ))}
                        </ul>
                    }
                </div>
                <h5 style={{ paddingLeft: "100px" }}>Manual Sales Upload <span style={{ color: "GrayText" }}>CSV File</span></h5>
                <div style={{ paddingLeft: "100px"}}>
                    <h6>Please select a return type &nbsp;&nbsp;&nbsp;
                        <select name="SaleType" id="SaleType" onChange={(e) => handleSaleType(e)} value={saleType}>
                    <option value="Residential">Residential</option>
                    <option value="Rural">Rural</option>
                    </select>
                    </h6>
                </div>
                <div style={{ paddingLeft: "120px", fontSize: '15px' }}>
                    <input type="file" accept=".csv" onChange={handleSalesFileChange} />
                    <Button style={{ backgroundColor: "#331b8c", border: 'none' }} size="sm" onClick={handleManualSalesUpload}>Upload CSV</Button>
                </div>
            </div>
                
            
        </>

    )
}